// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Body{position:fixed;z-index:10;left:10rem;width:calc(100% - 14rem);height:100vh}.Body.full{width:calc(100% - 4rem);left:0}@media(max-width: 768px){.Body{left:0;width:calc(100% - 4rem)}}", ""]);
// Exports
module.exports = exports;
